import { render, staticRenderFns } from "./TagDetail.vue?vue&type=template&id=1849a5ca&scoped=true&"
import script from "./TagDetail.vue?vue&type=script&lang=js&"
export * from "./TagDetail.vue?vue&type=script&lang=js&"
import style0 from "./TagDetail.vue?vue&type=style&index=0&id=1849a5ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1849a5ca",
  null
  
)

export default component.exports